import { IPlan } from '../interfaces/plans-informations.interface';


export interface IModalitiesProps {
	fullBoard: boolean;
	breakfast: boolean;
	halfBoard: boolean;
	luxuryHotels: boolean;
	allInclusive: boolean;
	fullBoardFirst?: boolean;
	halfBoardFirst?: boolean;
	breakfastFirst?: boolean;
	allInclusiveFirst?: boolean;
	internationalHotels: boolean;
	luxuryHotelsFirst?: boolean;
	internationalHotelsFirst?: boolean;
}


const replaceLabelModality = (label: string, first: boolean) => {
	if (!first) {
		return label.replace('Opções', 'Mais opções');
	}
	return label;
}

const includes = (type: string, isCheck: boolean, label: string, first: boolean) => {
	const defaultClass = `plans-informations__cards-container__item-column__body-${type}`;
	const checkClass = `${isCheck ? defaultClass + '__check' : defaultClass + '__uncheck'}`;
	const firstClass = first ? `${defaultClass}__first` : `${defaultClass}__not-first`;
	return {
		class: `${defaultClass} ${checkClass} ${firstClass}`,
		iconClass: `${defaultClass}__icon ${firstClass}__icon`,
		icon: isCheck ? 'check' : 'close',
		fill: isCheck ? '#5CB030' : '#E52538',
		label: replaceLabelModality(label, first),
	};
}

const badgeClass = (id: number): IPlan['badgeClass'] => {
	const classDefault = `plans-informations__cards-container__badge-${id}`;
	return {
		class: classDefault,
		icon: `${classDefault}__icon`,
		text: `${classDefault}__text`,
	};
};

const modalities = (param: IModalitiesProps): IPlan['modalities'] => {
	const data = [];
	const breakfastLabel = 'Café da manhã';
	const halfBoardLabel = 'Opções com Meia-pensão';
	const fullBoardLabel = 'Opções com Pensão completa';
	const internationalHotelsLabel = 'Opções de Hotéis Internacionais';
	const allInclusiveLabel = 'Opções de Resorts All inclusive';
	const luxuryHotelsLabel = 'Hotéis Luxuosos';
	const breakfast = param.breakfast;
	const breakfastFirst =  param.breakfastFirst;
	const halfBoard = param.halfBoard;
	const halfBoardFirst = param.halfBoardFirst;
	const fullBoard = param.fullBoard;
	const fullBoardFirst = param.fullBoardFirst;
	const internationalHotels = param.internationalHotels;
	const internationalHotelsFirst = param.internationalHotelsFirst;
	const allInclusive = param.allInclusive;
	const allInclusiveFirst = param.allInclusiveFirst;
	const luxuryHotels = param.luxuryHotels;
	const luxuryHotelsFirst = param.luxuryHotelsFirst;
	data.push(includes('breakfast', breakfast, breakfastLabel, breakfastFirst));
	data.push(includes('half-board', halfBoard, halfBoardLabel, halfBoardFirst));
	data.push(includes('full-board', fullBoard, fullBoardLabel, fullBoardFirst));
	data.push(includes('international-hotels', internationalHotels, internationalHotelsLabel, internationalHotelsFirst));
	data.push(includes('all-inclusive', allInclusive, allInclusiveLabel, allInclusiveFirst));
	data.push(includes('luxury-hotels', luxuryHotels, luxuryHotelsLabel, luxuryHotelsFirst));
	return data;
};

const COMPLETO: IPlan = {
	id: 1,
	flag: 'Mais vendido',
	icon: 'single-bag',
	title: 'COMPLETO',
	plans: 'Hotéis do plano Completo',
	prices: [
		{
			id: 1,
			daily: 7,
			people: 2,
			price: 266.12,
			class: 'plans-informations__cards-container__item-column__footer-lowest-price',
			categoryCode: '08',
		},
	],
	badgeClass: badgeClass(1),
	modalities: modalities({
		breakfast: true,
		halfBoard: false,
		fullBoard: false,
		allInclusive: false,
		luxuryHotels: false,
		breakfastFirst: true,
		internationalHotels: false,

	}),
	containerClass: 'plans-informations__cards-container__1',
}

const IDEAL: IPlan = {
	id: 2,
	flag: undefined,
	icon: 'couples-bags',
	title: 'IDEAL',
	plans: 'Hotéis dos planos Completo + Ideal',
	prices: [
		{
			id: 1,
			daily: 7,
			people: 2,
			price: 382.67,
			class: 'plans-informations__cards-container__item-column__footer-lowest-price',
			categoryCode: '11',
		},
	],
	badgeClass: badgeClass(2),
	modalities: modalities({
		breakfast: true,
		breakfastFirst: true,
		halfBoard: true,
		halfBoardFirst: true,
		fullBoard: false,
		internationalHotels: false,
		allInclusive: false,
		luxuryHotels: false,
	}),
	containerClass: 'plans-informations__cards-container__2',
}

const EXCLUSIVO: IPlan = {
	id: 3,
	flag: undefined,
	icon: 'bags-trolley',
	title: 'EXCLUSIVO',
	plans: 'Hotéis dos planos Completo, Ideal e Exclusivo',
	prices: [
		{
			id: 1,
			daily: 7,
			people: 2,
			price: 499.22,
			class: 'plans-informations__cards-container__item-column__footer-lowest-price',
			categoryCode: '14',
		},
	],
	badgeClass: badgeClass(3),
	modalities: modalities({
		breakfast: true,
		breakfastFirst: true,
		halfBoard: true,
		fullBoard: true,
		fullBoardFirst: true,
		internationalHotels: true,
		internationalHotelsFirst: true,
		allInclusive: false,
		luxuryHotels: false,
	}),
	containerClass: 'plans-informations__cards-container__3',
}

const REQUINTE: IPlan = {
	id: 4,
	flag: 'Resorts',
	icon: 'bags-trolley-star',
	title: 'REQUINTE',
	plans: 'Hotéis dos planos Completo + Ideal + Exclusivo + Requinte',
	prices: [
		{
			id: 1,
			daily: 7,
			people: 2,
			price: 635.20,
			class: 'plans-informations__cards-container__item-column__footer-lowest-price',
			categoryCode: '17',
		},
	],
	badgeClass: badgeClass(4),
	modalities: modalities({
		breakfast: true,
		breakfastFirst: true,
		halfBoard: true,
		fullBoard: true,
		internationalHotels: true,
		allInclusive: true,
		allInclusiveFirst: true,
		luxuryHotels: false,
	}),
	containerClass: 'plans-informations__cards-container__4',
}

const PLUS: IPlan = {
	id: 5,
	flag: undefined,
	icon: 'bags-trolley-stars',
	title: 'PLUS',
	plans: 'Hotéis dos planos Completo, Ideal, Exclusivo, Requinte e Plus',
	prices: [
		{
			id: 1,
			daily: 7,
			people: 2,
			price: 771.17,
			class: 'plans-informations__cards-container__item-column__footer-lowest-price',
			categoryCode: '28',
		},
	],
	badgeClass: badgeClass(5),
	modalities: modalities({
		breakfast: true,
		breakfastFirst: true,
		halfBoard: true,
		fullBoard: true,
		internationalHotels: true,
		allInclusive: true,
		luxuryHotels: false,
	}),
	containerClass: 'plans-informations__cards-container__5',
}

const BLACK: IPlan = {
	id: 6,
	flag: 'Hotéis de Luxo',
	icon: 'bags-trolley-premium',
	title: 'BLACK',
	plans: 'Todos os hotéis da Montreal',
	prices: [
		{
			id: 1,
			daily: 7,
			people: 2,
			price: 1062.55,
			class: 'plans-informations__cards-container__item-column__footer-lowest-price',
			categoryCode: '31',
		},
	],
	badgeClass: badgeClass(6),
	modalities: modalities({
		breakfast: true,
		breakfastFirst: true,
		halfBoard: true,
		fullBoard: true,
		internationalHotels: true,
		allInclusive: true,
		luxuryHotels: true,
		luxuryHotelsFirst: true,
	}),
	containerClass: 'plans-informations__cards-container__6',
}

export const PLANS_INFORMATIONS: Array<IPlan> = [
	COMPLETO,
	IDEAL,
	EXCLUSIVO,
	REQUINTE,
	PLUS,
	BLACK,
];
